import React, { useEffect, useRef, useState } from "react";
import "../Style/join.css";
import networkImg from "../assets/blog.png";

export default function JoinNetwork() {
  const sectionRef = useRef(null);
  const cardRef    = useRef(null);

  const [visible,   setVisible]   = useState(false);
  const [tilt,      setTilt]      = useState({ x: 0, y: 0 });
  const [glare,     setGlare]     = useState({ x: 50, y: 50 });
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top  + rect.height / 2;
    setTilt({
      x: -((e.clientY - cy) / (rect.height / 2)) * 18,
      y:  ((e.clientX - cx) / (rect.width  / 2)) * 18,
    });
    setGlare({
      x: ((e.clientX - rect.left) / rect.width)  * 100,
      y: ((e.clientY - rect.top)  / rect.height) * 100,
    });
  };

  const handleMouseLeave = () => {
    setTilt({ x: 0, y: 0 });
    setGlare({ x: 50, y: 50 });
    setIsHovered(false);
  };

  // Both sections live on the same page, so scroll up/down to
  // the Job Details section instead of navigating.
  const goToCareerOpportunities = () => {
    console.log("Submit Your Resume clicked");
    const target = document.getElementById("jobdetails");
    console.log("Target element found:", target);

    if (!target) {
      console.warn(
        '⚠️ No element with id="jobdetails" found in the DOM. ' +
        "Make sure CareerOpportunity's <section> has id=\"jobdetails\" and is rendered on this page."
      );
      return;
    }

    target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className={`jn-section ${visible ? "jn-visible" : ""}`} ref={sectionRef}>

      <div className="jn-blob jn-blob-1" />
      <div className="jn-blob jn-blob-2" />
      <div className="jn-grain" />

      <div className="jn-container">

        {/* ── LEFT ── */}
        <div className="jn-left">
          <p className="jn-eyebrow">
            <span className="jn-dot" />
            Talent Network · Always Open
          </p>

          <h2 className="jn-title">
            <span className="jn-line">Join Our</span>
            <span className="jn-line">Talent <em>Network</em></span>
          </h2>

          <p className="jn-desc">
            We're always looking for passionate individuals to be part of our
            journey. Share your profile and we'll connect when the perfect
            opportunity aligns — no waiting rooms, just real careers.
          </p>

          <button className="jn-btn" type="button" onClick={goToCareerOpportunities}>
            <span className="jn-btn-fill" />
            <span className="jn-btn-label">Submit Your Resume</span>
            <span className="jn-btn-arrow">→</span>
          </button>
        </div>

        {/* ── RIGHT — 3D CARD ── */}
        <div className="jn-right">
          <div className="jn-orbit jn-orbit-1" />
          <div className="jn-orbit jn-orbit-2" />
          <div className="jn-orbit-dot jn-orbit-dot-1" />
          <div className="jn-orbit-dot jn-orbit-dot-2" />

          <div
            className={`jn-card-wrap ${isHovered ? "hovered" : ""}`}
            ref={cardRef}
            onMouseMove={handleMouseMove}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={handleMouseLeave}
            style={{
              transform: `perspective(1000px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg) scale(${isHovered ? 1.04 : 1})`,
            }}
          >
            <div
              className="jn-glare"
              style={{
                background: `radial-gradient(circle at ${glare.x}% ${glare.y}%, rgba(255,255,255,0.18) 0%, transparent 65%)`,
              }}
            />
            <img src={networkImg} alt="Join Network" className="jn-img" />
            <div className="jn-overlay" />
            <div className="jn-live-badge">
              <span className="jn-live-pulse" />
              Hiring Now
            </div>
            <div className="jn-glass-bar">
              <p className="jn-glass-title">Your next chapter starts here</p>
              <p className="jn-glass-sub">Opportunities · Growth · Impact</p>
            </div>
            <div className="jn-edge-glow" />
          </div>

          <div className="jn-shadow-card" />
        </div>

      </div>

    </section>
  );
}